import type { SandboxAdminQueryParams } from "shell/console/types";

import { getSessionHeaders } from "shell/platform/lib/oidcClient";

const proxyPath = import.meta.env.VITE_SANDBOX_PROXY_PATH;
const apiUrl = import.meta.env.VITE_SANDBOX_API_URL;
const SANDBOX_ADMIN_API_BASE = proxyPath ?? apiUrl;

const buildUrl = (path: string, params?: SandboxAdminQueryParams): string => {
  const base = SANDBOX_ADMIN_API_BASE.endsWith("/")
    ? SANDBOX_ADMIN_API_BASE.slice(0, -1)
    : SANDBOX_ADMIN_API_BASE;
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  const url = `${base}${cleanPath}`;
  if (!params) return url;

  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.set(key, String(value));
    }
  });
  const queryString = search.toString();
  return queryString ? `${url}?${queryString}` : url;
};

const toStringHeaders = (
  headers: Record<string, string | number>,
): Record<string, string> =>
  Object.fromEntries(
    Object.entries(headers).map(([key, value]) => [key, String(value)]),
  );

export const sandboxAdminFetch = async (
  path: string,
  {
    method,
    body,
    params,
  }: {
    method?: string;
    body?: unknown;
    params?: SandboxAdminQueryParams;
  } = {},
): Promise<Response> => {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    Accept: "application/json",
    ...toStringHeaders(getSessionHeaders()),
  };

  const init: RequestInit = { method: method ?? "GET", headers };
  if (body !== undefined) init.body = JSON.stringify(body);

  return fetch(buildUrl(path, params), init);
};
